import Axios from "axios";
import Jwt from "jsonwebtoken";
import {getRefreshToken, saveRefreshToken, saveToken} from "./Storage";

const defaultOptions = {
    method: 'POST',
    baseURL: process.env.REACT_APP_BASE_API,
    data: {},
    headers: {
        "Content-Type": "application/json",
    }
}

const axiosInstance = Axios.create(defaultOptions);

axiosInstance.interceptors.response.use(
    response => {
        // Ensure the response is in JSON format
        if (response.headers['content-type']?.includes('application/json')) {
            if ([82, 83, 84, 85, 86, 87].includes(response.data.code)) {
                const configData = {...response.config}.data;
                return Axios.create(defaultOptions).request({
                    method: "POST",
                    url: "/user-service/v3/auth/refreshtoken",
                    data: {
                        api_key: process.env.REACT_APP_API_KEY,
                        ip: "string",
                        dvId: "string",
                        jwt: getRefreshToken(),
                        os: "string",
                        serviceCode: process.env.REACT_APP_SERVICE_CODE,
                        rTokenType: 0
                    }
                })
                    .then((next) => {
                        if (next.data?.code === 0) {
                            saveToken(next.data?.data?.access_token);
                            saveRefreshToken(next.data?.data?.refresh_token);
                            const config: any = {...response.config};
                            const data = configData instanceof FormData ? configData : JSON.parse(configData);
                            if (data instanceof FormData) data.set("token", next.data?.data?.access_token);
                            else data.token = next.data?.data?.access_token;
                            config.data = data;

                            return axiosInstance({
                                method: config.method,
                                baseURL: config.baseURL,
                                url: config.url,
                                data: config.data
                            });
                        } //
                        else {
                            window.location.href = window.location.origin + process.env.PUBLIC_URL;
                            return Promise.reject(response.data);
                        }
                    })
                    .catch(error => {
                        window.location.href = window.location.origin + process.env.PUBLIC_URL;
                        return Promise.reject(error);
                    })
            } //
            else if (response.status < 400) return response.data
            else return response.data;
        } else {
            throw new Error('Response is not in JSON format');
        }
    },
    error => {
        if (error.response) {
            return Promise.reject(error.response.data ? error.response.data : error.response);
        } else {
            return Promise.reject(error)
        }
    }
);

export function ClientRequest<T>(url: string, params: any = {}, method: string = 'POST') {
    return axiosInstance({
        ...defaultOptions,
        url: url,
        data: params,
        timeout: 15000,
        method: method,
    }) as Promise<ClientResponse<T>>;
}

export const createJwt = (data: any, key: string = process.env.REACT_APP_API_KEY as string, sec: string = process.env.REACT_APP_API_SEC as string) => {
    let payload = {
        jti: (Date.now() * 10000 + 621355968000000000).toString(),
        iss: key,
        exp: parseInt(Math.floor(Date.now() / 1000).toString()) + parseInt("120"),
        nbf: parseInt(Math.floor(Date.now() / 1000).toString()),
        sid: 0,
        jdt: JSON.stringify(data),
    };

    return Jwt.sign(payload, sec as Jwt.Secret);
}

export interface ClientResponse<T> {
    code: number,
    data: T,
    message: string,
}
